/**
 * Digits in a one-time code, by delivery channel.
 * SMS codes come from the Injozi OTP Service, which issues 4-digit codes (confirmed
 * live 30 Oct 2026); email codes are generated by auth-service and are 6 digits.
 */
export type CodeChannel = 'sms' | 'email';

export const SMS_CODE_LENGTH = 4;
export const EMAIL_CODE_LENGTH = 6;

export const codeLength = (channel: CodeChannel): number =>
  channel === 'sms' ? SMS_CODE_LENGTH : EMAIL_CODE_LENGTH;
